import { TimetableTemplate } from '../_models/timetable-template';
import {DbService,TIMETABLE_STORE_NAME, TIMETABLE_STORE_INDEX_BATCH } from './DbService';

class TimetableService {

  dbservice:DbService = new DbService()
  
  constructor(){
    this.dbservice.connect()
  }

  addTimetables(timetables: TimetableTemplate[]): any {
    return this.dbservice.saveAll(TIMETABLE_STORE_NAME, timetables);
  }

  getTimetablesForBatch(batchId: number): Promise<TimetableTemplate[]> {
    return this.dbservice.getByIndex(TIMETABLE_STORE_NAME, TIMETABLE_STORE_INDEX_BATCH, batchId);
  }
}

export default  TimetableService